module.exports = __webpack_public_path__ + "assets/img/11-m.00e0ae1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/photo/objects/11-m.jpg
// module id = Dhrx
// module chunks = 0